import { mode } from '@chakra-ui/theme-tools';
import '@fontsource/orbitron/400.css';
import '@fontsource/orbitron/500.css';
import '@fontsource/orbitron/600.css';
import '@fontsource/orbitron/700.css';
import './styles.css';

export const globalStyles = {
  styles: {
    global: (props) => ({
      body: {
        bg: mode('white', '#03050C')(props), 
        fontFamily: "'Orbitron', sans-serif",
        position: 'relative'
      },
      '*': {
        overflow: 'hidden',
        outline: 'none !important',
        userSelect: 'none !important'
      },
      html: {
        fontFamily: "'Orbitron', sans-serif"
      },
      '.chakra-modal__content': { 
        bg: 'transparent !important',
        boxShadow: 'unset !important'
      },
      '.hidden': {
        opacity: '0',
        pointerEvents: 'none'
      }
    })
  }
};
